import { ApiProviderStatus } from '@repo/api-kit/queries/register-kyc';
import { verification as identityVerification } from '@repo/api-kit/identity-verification';

const { ApiRequestCredentialsErrorsConflictError } = identityVerification.firstparty.v4;

export const REDIRECT_DELAY = 4000;
export const TOAST_TIMEOUT = 5000;

export const SEND_SMS_TEMPLATE = {
  IDNOW_APP_LINK: 'idnow-app-link',
  QONTO_VERIFICATION_FOURTHLINE: 'qonto-verification-fourthline',
};

export const TERMINAL_PROVIDER_STATUSES: ReadonlySet<string> = new Set([
  ApiProviderStatus.succeeded,
  ApiProviderStatus.rejected,
  ApiProviderStatus.process_finished,
  ApiProviderStatus.waiting_results,
]);

export const KYC_SUCCESS_STATUSES: ReadonlySet<string> = new Set([
  ApiProviderStatus.succeeded,
  ApiProviderStatus.process_finished,
]);

export const POI_RENEWAL_ACTIONS = [
  'fourthline-poi-renewal',
  'account-suspended-expired-poi',
  'account-restricted-expired-poi',
] as const;

export const NOT_RETRYABLE_ERROR_CODE =
  ApiRequestCredentialsErrorsConflictError.CONFLICT_ERROR_IDENTITY_VERIFICATION_NOT_RETRYABLE;
